import React from 'react'
import "../Assets/styles/about.css"
import wert from "../Assets/images/wert.jpg"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { FcAbout } from "react-icons/fc";
import { CiCircleCheck } from "react-icons/ci";

const About = () => {
  return (
    <>
      <div className="about">
        <div className="about-bg">
        <h1>< FcAbout/></h1>
        <h4><a href='/home'>Home </a><span className='dot'></span> About</h4>
        </div>
      </div>
      <div className="container-lg mission">
        <div className="row">
          <div className="col-lg-6 wert">
            <img src={wert} alt="wert" />
          </div>
          <div className="col-lg-6 legacy">
            <h1>About Our Agency</h1>
            <p>We help visionary enterpreneurs bring their creative ideas to life without having to quit their day jobs, spend their savings on a technical partner.</p>
            <Tabs
              defaultActiveKey="profile"
              id="justify-tab-example"
              className="mb-3"
              justify
            >
            <Tab eventKey="home" title="Our History">
              <p>A vision to <span>revolutionize</span> the software development industry.</p>
              <ul className='history'>
              <li>
              <CiCircleCheck className='circlll' /> <p>Commitment to accessibility and innovation in software development services.</p>
              </li>
              <li>
              <CiCircleCheck className='circlll' /> <p>Making software development accessible to diverse individuals and businesses.</p>
              </li>
              <li>
              <CiCircleCheck className='circlll' /> <p>Educate Creatives on The Ups & Downs of Entreprenuership</p>
              </li>
              <li>
              <CiCircleCheck className='circlll' /> <p>First steps toward a future of accessible technology innovation.</p>
              </li>
              </ul>
              <button className='bret'>Get Started</button>
            </Tab>
            <Tab eventKey="profile" title="Our Mission">
              <p>If you can <span>dream</span> it, we can build it</p>
              <ul className='history'>
              <li>
              <CiCircleCheck className='circlll' /> <p>Enable aspiring entrepreneurs to realize their visions.</p>
              </li>
              <li>
              <CiCircleCheck className='circlll' /> <p>Champion accessibility and inclusivity in software development solutions.</p>
              </li>
              <li>
              <CiCircleCheck className='circlll' /> <p>Bridge the gap between tech expertise and entrepreneurial ambition.</p>
              </li>
              <li>
              <CiCircleCheck className='circlll' /> <p>Harness technology to empower individuals and businesses worldwide.</p>
              </li>
              </ul>
              <button className='bret'>Get Started</button>
            </Tab>
            <Tab eventKey="longer-tab" title="Active Support">
              <p>We are with you, every <span>step</span> of the way</p>
              <ul className='history'>
              <li>
              <CiCircleCheck className='circlll' /> <p>Swift, reliable help for your software development journey.</p>
              </li>
              <li>
              <CiCircleCheck className='circlll' /> <p>Anticipating needs, providing proactive solutions for seamless development.</p>
              </li>
              <li>
              <CiCircleCheck className='circlll' /> <p>Easily accessible expertise to support your software development endeavors.</p>
              </li>
              <li>
              <CiCircleCheck className='circlll' /> <p>Communicate with your team or partner YOUR way.</p>
              </li>
              </ul>
              <button className='bret'>Get Started</button>
            </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  )
}

export default About